import { render } from "./PropertyAllocationModal.vue?vue&type=template&id=136897b4&scoped=true"
import script from "./PropertyAllocationModal.vue?vue&type=script&lang=js"
export * from "./PropertyAllocationModal.vue?vue&type=script&lang=js"

import "./PropertyAllocationModal.vue?vue&type=style&index=0&id=136897b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136897b4"]])

export default __exports__